import { render, staticRenderFns } from "./BankAccountDetails.vue?vue&type=template&id=4c50619c&scoped=true"
import script from "./BankAccountDetails.vue?vue&type=script&lang=js"
export * from "./BankAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./BankAccountDetails.vue?vue&type=style&index=0&id=4c50619c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c50619c",
  null
  
)

export default component.exports